export function downloadChartAsPNG(chart, filename = 'chart.png') {
    if (!chart) return;
  
    // Temporarily set background to transparent
    chart.setOption({
      backgroundColor: 'rgba(0, 0, 0, 0)'
    });
  
    // Get chart as PNG data URL
    const url = chart.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#00000000'
    });
  
    // Reset background to transparent (if it was different before)
    chart.setOption({
      backgroundColor: 'transparent'
    });
  
    // Create and trigger download link
    const link = document.createElement('a');
    link.download = filename;
    link.href = url;
    link.click();
  }